/** @file Grows the open draw while page and blend match, else flushes it and opens a new one. */
import type { RenderBuffers } from '../renderBuffers';
import type { BuildState } from './buildState';
import { flushDraw } from './flushDraw';

/** Adds one slot's index and vertex ranges to the open draw (same page and blend) or starts a new draw. */
export function appendDraw(out: RenderBuffers, st: BuildState, page: number, blend: number, indexStart: number, indexCount: number, vertexStart: number, vertexCount: number): void {
  const open = st.draw;
  if (open[0] === page && open[1] === blend) {
    open[3] = (open[3] ?? 0) + indexCount;
    open[5] = (open[5] ?? 0) + vertexCount;
    return;
  }
  flushDraw(out, st);
  open[0] = page;
  open[1] = blend;
  open[2] = indexStart;
  open[3] = indexCount;
  open[4] = vertexStart;
  open[5] = vertexCount;
}
